import { i18n } from '@/core/lang/core.i18n';
import { ErrorsMap } from '../enums/errors-map.enum';
import { Error, IErrorModal } from '../interfaces/error.interface';
import { Errors } from '../values/errors.values';
import KEYS from '@/values/keys';

class ErrorProviderClass {

  getError(backendCode: string, errorDetails:any=[]): Error {
    const error = ErrorsMap[backendCode];
    const response = Errors[error] || Errors.ERR000;
    
    return {
      code: response.code,
      message: i18n.t(response.message).toString(),
      errors: errorDetails.map(e => this.getError(e.status || e.code))
    }
  }

  getErrorsOfTheRequest(errors: any = []): Error[] {
    const errorDefault = Errors.ERR002;

    return errors.map(e => {
      const message = Errors[e.status]?.message ? i18n.t(Errors[e.status].message).toString() : errorDefault.message;
      
      return {
        code: e.status || errorDefault.code,
        title: 'Error',
        message,
        type: KEYS.EVENT_TYPES.DANGER,
      }
    })
  }
}

export const ErrorProvider = new ErrorProviderClass();